import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import { NavLink } from 'react-router-dom';
import normaliseTrailingSlash from 'util/misc/normalise-trailing-slash';
import { linkToDashboardByUser } from 'util/misc/link-to-dashboard';
import classnames from 'classnames';
import LazyImage from 'components/lazy-image';
import { register, unregister } from 'util/dom/channeled-interactionobserver';

class CmsFavoriteCategory extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        category: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired,
        activeRegion: PropTypes.object,
        image: PropTypes.shape({
            title: PropTypes.string,
            src: PropTypes.shape({
                '@1': PropTypes.string,
                '@2': PropTypes.string,
            }),
            alt: PropTypes.string,
        }),
        routerRegistry: PropTypes.object.isRequired,
    };

    state = {
        isVisible: false,
    };

    componentDidMount() {
        register(this, 'fav-category', {
            threshold: 0.05,
        });
    }

    componentWillUnmount() {
        unregister(this);
    }

    getBackgroundImage(image) {
        if (!this.state.isVisible) {
            return null;
        }

        return `url(${ image.src['@2'] })`;
    }

    render() {
        const { title, icon, image, category, activeRegion } = this.props;
        return (
            <div ref="root">
                <NavLink
                    className="cms-favorite-category u-reset"
                    to={ normaliseTrailingSlash(`${ linkToDashboardByUser(activeRegion) }${ category }`) }
                    style={ { backgroundImage: this.getBackgroundImage(image) } }>
                    <div
                        className={ classnames('cms-favorite-category--overlay', { 'cms-favorite-category--overlay__longtext': title.length > 12 }) }>
                        <LazyImage>
                            <img className="cms-favorite-category--icon" data-src={ icon }/>
                        </LazyImage>
                        <div className="cms-favorite-category--title">{ title }</div>
                    </div>
                </NavLink>
            </div>
        );
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        activeRegion: 'region.active',
        routerRegistry: 'router.registry',
    }),
    null
)(CmsFavoriteCategory);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/favorite-category/index.js